import React from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { PenTool } from 'lucide-react';

export function AssinaturaDialog({ 
  open, 
  onOpenChange, 
  form, 
  setForm, 
  onSubmit, 
  onReset,
  contrato
}) {
  const handleClose = () => {
    onOpenChange(false);
    onReset?.();
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg">
        <form onSubmit={(e) => { e.preventDefault(); onSubmit(); }}>
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2">
              <PenTool className="w-5 h-5 text-blue-600" />
              Assinatura Digital
            </DialogTitle>
            <DialogDescription>
              Assine digitalmente o contrato {contrato?.numero_contrato}
            </DialogDescription>
          </DialogHeader>
          
          <div className="space-y-4 py-4">
            <div>
              <Label>Nome Completo do Signatário *</Label>
              <Input 
                value={form.nome_signatario}
                onChange={(e) => setForm(prev => ({ ...prev, nome_signatario: e.target.value }))}
                placeholder="Nome completo"
                data-testid="input-nome-signatario"
              />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label>CPF</Label>
                <Input 
                  value={form.cpf_signatario}
                  onChange={(e) => setForm(prev => ({ ...prev, cpf_signatario: e.target.value }))}
                  placeholder="000.000.000-00"
                />
              </div>
              <div>
                <Label>Cargo</Label>
                <Input 
                  value={form.cargo_signatario}
                  onChange={(e) => setForm(prev => ({ ...prev, cargo_signatario: e.target.value }))}
                  placeholder="Ex: Diretor"
                />
              </div>
            </div>
            
            <div className="p-4 bg-slate-50 rounded-lg border border-slate-200">
              <p className="text-sm text-slate-600 mb-2">
                Ao clicar em "Assinar Contrato", você confirma que:
              </p>
              <ul className="text-xs text-slate-500 space-y-1 list-disc list-inside">
                <li>Leu e concorda com todos os termos do contrato</li>
                <li>Possui autorização para assinar em nome da empresa</li>
                <li>Esta assinatura digital tem validade legal</li>
              </ul>
            </div>
          </div>
          
          <DialogFooter>
            <Button type="button" variant="outline" onClick={handleClose}>
              Cancelar
            </Button>
            <Button type="submit" className="bg-blue-600 hover:bg-blue-700" data-testid="btn-assinar">
              <PenTool className="w-4 h-4 mr-2" />
              Assinar Contrato
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}
